import { THEME_COLORS } from "../util/themes";

export const OVERLAY_STYLES = {
    discount: {
        position: "absolute" as const,
        left: 0,
        top: 0,
        backgroundColor: THEME_COLORS.discount,
        color: "white",
        px: 1.5,
        py: 0.5,
        textAlign: "center" as const,
        lineHeight: 1.2,
        zIndex: 3,
    },
    stock: {
        position: "absolute" as const,
        top: 0,
        left: 0,
        backgroundColor: THEME_COLORS.overlay.darkStrong,
        color: THEME_COLORS.primary,
        p: 1,
        py: 0.7,
        zIndex: 10,
    },
    imageCounter: {
        position: "absolute" as const,
        top: 0,
        right: 0,
        backgroundColor: THEME_COLORS.overlay.dark,
        color: THEME_COLORS.primary,
        px: 1.5,
        py: 0.5,
        zIndex: 10,
    }
} as const;














